const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const GARMENT_TYPES = {
  "tshirt": { name: "T-Shirt", price: 6.75 },
  "hoodie": { name: "Hoodie", price: 25.00 },
  "tank": { name: "Tank Top", price: 6.50 },
  "longsleeve": { name: "Long Sleeve", price: 12.00 },
  "polo": { name: "Polo Shirt", price: 15.00 },
  "crewneck": { name: "Crewneck Sweatshirt", price: 20.00 },
  "hat": { name: "Hat", price: 8.00 }
};

export const PRINT_LOCATIONS = {
  "front": { name: "Front", icon: "🎯" },
  "back": { name: "Back", icon: "🔄" },
  "left_chest": { name: "Left Chest", icon: "📍" },
  "right_chest": { name: "Right Chest", icon: "📍" },
  "left_sleeve": { name: "Left Sleeve", icon: "👈" },
  "right_sleeve": { name: "Right Sleeve", icon: "👉" }
};
